import React, { memo } from 'react';
import { useBranding } from '@src/theme/branding/useBranding';
import { Button, Switch } from 'antd';
import { SIDE_MENU_EVENTS } from '../sideMenu';
import { LIGHT_TYPE } from '@src/components/scene/react-three-components/lightTemplate';

const Lights = ({
  items,
  callBack,
  type,
  lightTemplate,
  onChangeCSMLight,
  styles,
  selectedSkybox,
  selectedSceneTemplate,
}) => {
  const { isZepeto } = useBranding();

  if (isZepeto) {
    return (
      <>
        <div
          style={{
            textAlign: 'center',
            marginBottom: '10px',
            gap: '10px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
              alignSelf: 'center',
            }}
          >
            <p>Template Lights</p>
          </div>

          {items &&
            items.slice(1, 5).map((element, index) => {
              return (
                <div key={`${type}-${index}-templates-1`}>
                  <Button
                    data-cy='scene-light'
                    style={{ width: '100%' }}
                    className={
                      lightTemplate === index
                        ? 'sidedrawer-element-selected'
                        : ''
                    }
                    onClick={() => {
                      callBack({ ...element, type, index });
                    }}
                  >
                    {`Light Template ${index + 1}`}
                  </Button>
                </div>
              );
            })}
        </div>
      </>
    );
  }
  return (
    <>
      <div
        style={{
          textAlign: 'center',
          marginBottom: '10px',
          gap: '10px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '20px',
            alignSelf: 'center',
          }}
        >
          <p>Shadows light</p>
          <Switch onChange={onChangeCSMLight} defaultChecked />
        </div>
        <Button
          className={styles.addLightsButton}
          onClick={() =>
            callBack({
              type: SIDE_MENU_EVENTS.LIGHTSADDED,
              typeLight: LIGHT_TYPE.AMBIENT,
            })
          }
        >
          Add ambient light
        </Button>
        <Button
          className={styles.addLightsButton}
          onClick={() =>
            callBack({
              type: SIDE_MENU_EVENTS.LIGHTSADDED,
              typeLight: LIGHT_TYPE.DIRECTIONAL,
            })
          }
        >
          Add directional light
        </Button>
        <Button
          className={styles.addLightsButton}
          onClick={() =>
            callBack({
              type: SIDE_MENU_EVENTS.LIGHTSADDED,
              typeLight: LIGHT_TYPE.POINTLIGHT,
            })
          }
        >
          Add point light
        </Button>
        <Button
          className={styles.addLightsButton}
          onClick={() =>
            callBack({
              type: SIDE_MENU_EVENTS.LIGHTSADDED,
              typeLight: LIGHT_TYPE.SPOTLIGHT,
            })
          }
        >
          Add spot light
        </Button>
      </div>
    </>
  );
};

export default memo(Lights);
